import { ActionType, getType } from 'typesafe-actions';
import * as debtCentreActions from './actions';
import { Debt } from '../types';

export type DebtCentreActionType = ActionType<typeof debtCentreActions>;

export interface DebtCentreState {
  allDebts: {
    data: Debt[] | null;
    loading: boolean;
  };
}

const initialState: DebtCentreState = {
  allDebts: {
    data: null,
    loading: false,
  },
};

const debtCentreReducer = (
  state: DebtCentreState = initialState,
  action: DebtCentreActionType,
): DebtCentreState => {
  switch (action.type) {
    case getType(debtCentreActions.getAllDebts.request):
      return {
        ...state,
        allDebts: {
          ...state.allDebts,
          loading: true,
        },
      };

    case getType(debtCentreActions.getAllDebts.success):
      return {
        ...state,
        allDebts: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(debtCentreActions.getAllDebts.failure):
      return {
        ...state,
        allDebts: {
          ...state.allDebts,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default debtCentreReducer;
